import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import { HeroFullBlockQuarter } from '@cotyorg/ccx-organism-hero';
import { FilterLeft } from '@cotyorg/ccx-organism-filter';
import {
  trackShopAllShadesEvent,
  trackViewMoreEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/product';
import StandardLayout from '../../templates/StandardLayout';

const showSwatchesForPage = ({ metaTitle }) => {
  const pages = ['Airbrush'];
  return pages.some((page) => metaTitle.includes(page));
};

const CategoryComponent = ({
  filterCategoryNames,
  filterMode,
  productSwatch,
  metaTitle,
  shouldUseBazaar,
}) => (
  <StandardLayout>
    <div className="category">
      <div className="category-hero">
        <HeroFullBlockQuarter
          heroStoreDataKey="HeroFullBlock"
          isUnderlined={false}
        />
      </div>

      <div className="grid-container">
        <div className="grid-x">
          <div className="cell xsmall-16 large-14 large-offset-1">
            <FilterLeft
              id="category-filter-left"
              isVariantFilter={filterMode === 'Variants'}
              categories={filterCategoryNames}
              selectedFilterIconSrc="/ccx-files/assets/cross.svg"
              dropdownClosedIconSrc="/ccx-files/assets/chevron-down.svg"
              dropdownOpenIconSrc="/ccx-files/assets/chevron-up.svg"
              accordionMinusIconSrc="/ccx-files/assets/minus.svg"
              accordionPlusIconSrc="/ccx-files/assets/plus.svg"
              refineIconSrc="/ccx-files/assets/refine.svg"
              modalCloseIconSrc="/ccx-files/assets/cross.svg"
              onShopAllVariantsClick={({ title, subcategory, action }) =>
                trackShopAllShadesEvent({
                  title,
                  subcategory,
                  action,
                })
              }
              onShowMoreClick={({ title, subcategory, action }) =>
                trackViewMoreEvent({
                  title,
                  subcategory,
                  action,
                })
              }
              cardoListProps={{
                showStarRating: shouldUseBazaar,
                imgRatingOnSrc: {
                  fullStar: '/ccx-files/assets/star-on.svg',
                  partialStar1: '/ccx-files/assets/partial-star-1.svg',
                  partialStar2: '/ccx-files/assets/partial-star-2.svg',
                  partialStar3: '/ccx-files/assets/partial-star-3.svg',
                  partialStar4: '/ccx-files/assets/partial-star-4.svg',
                  partialStar5: '/ccx-files/assets/partial-star-5.svg',
                  partialStar6: '/ccx-files/assets/partial-star-6.svg',
                  partialStar7: '/ccx-files/assets/partial-star-7.svg',
                  partialStar8: '/ccx-files/assets/partial-star-8.svg',
                  partialStar9: '/ccx-files/assets/partial-star-9.svg',
                },
                imgRatingOffSrc: '/ccx-files/assets/star-off.svg',
                contentTheme: 'transparent',
                isTitleUnderlined: false,
                isSmallTitle: true,
                headingLevel: 5,
                tagHeadingLevel: 6,
                fixedHeight: true,
                extraClass: 'product-list',
                showMoreIconSrc: '/ccx-files/assets/plus-within-circle.svg',
                showMoreIconWidth: 50,
                showSwatches: showSwatchesForPage({ metaTitle }),
                productSwatch,
                swatchLimit: 4,
                ...(filterMode === 'Variants' && { initialNumberToShow: 8 }),
                disableProgressiveLoading: true,
                ratingIconWidth: 20,
                ratingIconHeight: 20,
              }}
              modalTriggerButtonWidth={25}
              modalTriggerButtonHeight={25}
            />
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

CategoryComponent.propTypes = {
  filterCategoryNames: PropTypes.arrayOf(PropTypes.string),
  filterMode: PropTypes.string,
  productSwatch: PropTypes.shape(PropTypes.object),
  metaTitle: PropTypes.string,
  shouldUseBazaar: PropTypes.bool,
};

export default connect(({ content }) => ({
  filterCategoryNames: R.propOr([], 'filterCategoryNames')(content),
  filterMode: R.prop('filterMode')(content),
  productSwatch: R.prop('swatches')(content),
  metaTitle: R.path(['metaInformation', 'metaTitle'])(content),
  shouldUseBazaar: R.prop('shouldUseBazaar')(content),
}))(CategoryComponent);
